<template>
  <v-container fluid style="height: 100%;padding-bottom: 125px;">
    <v-row>
      <template>
        <v-col sm="12" lg="3" md="4" cols="12">
          <v-card :color="whitesmoke">
            <highcharts :id="this.$store.state.titleGraphic"></highcharts>
          </v-card>
        </v-col>

        <v-col sm="12" lg="9" md="8" cols="12">
          <v-card :color="whitesmoke">
            <highcharts :id="this.$store.state.titleGraphic + '2'"></highcharts>
          </v-card>
        </v-col>
      </template>
      <v-col sm="4" lg="3" cols="12" class="pb-5" style="max-height: 60px;">
        <v-text-field
          solo
          :label="$t('search')"
          append-icon="mdi-magnify"
          single-line
          v-model="search"
          :color="colorTheme"
        ></v-text-field>
      </v-col>
      <v-col lg="2" md="3" sm="4" cols="12" class="pb-5">
        <v-btn
          style="width: 100%; margin: 0;"
          large
          :color="colorTheme"
          class="regularText white--text"
          v-on:click="toExcel()"
        >
          {{ $t("download").toUpperCase() }}
          <v-icon class="icon-size pl-4" right dark>mdi-cloud-download</v-icon>
        </v-btn>
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <v-data-table
          :no-data-text="$t('noResults')"
          :headers="headersMetrics"
          :items="this.$store.state.PerformanceFleet"
          :search="search"
          :items-per-page="5"
          :loading="progressDetails"
          :loading-text="$t('loadingTextForTable')"
          class="myTableTD elevation-1"
          :sort-by="this.$store.state.shortByTable"
          :footer-props="{
            'items-per-page-text': $t('rows'),
            'items-per-page-all-text': $t('all')
          }"
        >
          <template v-slot:item.valuefuelDriving="{ item }">
            <span>{{ item.fuelDriving }}</span>
          </template>

          <template v-slot:item.valueFuelRalenti="{ item }">
            <span>{{ item.fuelRalenti }}</span>
          </template>

          <template v-slot:item.valueFuelPto="{ item }">
            <span>{{ item.fuelPto }}</span>
          </template>

          <template v-slot:item.valueEngineDriving="{ item }">
            <span>{{ item.engineDriving }}</span>
          </template>

          <template v-slot:item.valueEngineRalenti="{ item }">
            <span>{{ item.engineRalenti }}</span>
          </template>

          <template v-slot:item.valueEnginePto="{ item }">
            <span>{{ item.enginePto }}</span>
          </template>

          <template v-slot:item.valuePerformance="{ item }">
            <span>{{ item.performance }}</span>
          </template>

          <template v-slot:item.valueDistance="{ item }">
            <span>{{ item.distance }}</span>
          </template>

          <template v-slot:item.valueIntransitIncidents="{ item }">
            <span>{{ item.intransitIncidents }}</span>
          </template>

          <template v-slot:item.valueSpeedMax="{ item }">
            <span>{{ item.speedMax }}</span>
          </template>

          <template v-slot:item.act="{ item }">
            <v-btn
              text
              small
              :color="colorTheme"
              v-on:click="Performance(item)"
            >{{ $t("performance").toUpperCase() }}</v-btn>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >{{ $t("noResults") }} : "{{ search }}".</v-alert>
          <template
            v-slot:footer.page-text="items"
          >{{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }}</template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Chart } from "highcharts-vue";
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";

export default {
  name: "detailsAndTable",
  components: {
    highcharts: Chart
  },
  data() {
    return {
      search: "",
      metrics: []
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    var myTitle = JSON.parse(localStorage.getItem("mytitle"));
    if (myTitle != undefined && myTitle != null) {
      this.$store.commit("titleOfGraphic", myTitle);
    }
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("viewSkeletons", true);
    this.$store.commit("setPageHeader", [
      this.$t("dashboard"),
      this.$store.state.PageHeaderGraphTitle.toUpperCase(),
      "",
      "",
      true
    ]);
    this.$store.commit("skeleton", "outskeleton");
    this.$store.commit("skeletonTitle", "outskeletonTitle");
    this.$store.commit("skeletonPie", "outskeletonPie");
    this.$store.commit("skeletonFooter", "outskeletonFooter");
    this.$store.commit("skeletonColumn", "outskeletonColumn");
    this.$store.dispatch("getDetailsTable");
    this.$store.commit("changeHeadersMetrics");
  },
  mounted() {
    //se crea la grafica
    this.$store.dispatch("createDetailsChart");
    this.$store.commit("backgroundSkeleton");
    this.$store.commit("UnitSystemValues");
  },
  watch: {},
  computed: {
    ...mapState([
      "headersMetrics",
      "colorTheme",
      "viewSkeletons",
      "itemsDashboardCharts",
      "backgroundSkeleton",
      "itemsAwait",
      "whitesmoke",
      "titleAwait",
      "idgraphic",
      "titleOfGraphic",
      "progressDetails",
      "shortByTable"
    ]),
    skeleton: {
      get: function() {
        return this.$store.state.skeleton;
      },
      set: function() {}
    },
    skeletonTitle: {
      get: function() {
        return this.$store.state.skeletonTitle;
      },
      set: function() {}
    },
    skeletonPie: {
      get: function() {
        return this.$store.state.skeletonPie;
      },
      set: function() {}
    },
    skeletonFooter: {
      get: function() {
        return this.$store.state.skeletonFooter;
      },
      set: function() {}
    },
    skeletonColumn: {
      get: function() {
        return this.$store.state.skeletonColumn;
      },
      set: function() {}
    }
  },
  methods: {
    toExcel() {
      this.$store.dispatch("exportExcel");
    },
    Performance(item) {
      var vehicle = item.deviceId.replace("(", "").replace(")", "");
      vehicle = vehicle.split(" ");
      var id = vehicle.slice(-1).pop();
      var vehicleFinal = item.deviceId
        .replace("(", "")
        .replace(")", "")
        .replace(" ", "")
        .replace(id, "@" + id);

      localStorage.setItem("performanceVehicle", vehicleFinal);
      this.$router.push({ name: "individual" });
    }
  }
};
</script>

<style scoped>
@import "./../assets/styles/skeletons.css";
/* .v-data-table td, .v-data-table th {
    padding: 0px 21px;
} */
</style>
